import { CloseIcon, DeleteIcon, EditIcon, ViewIcon } from "@chakra-ui/icons";
import {
  DrawerFooter,
  Flex,
  Grid,
  GridItem,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import Spinner from "common/components/spinner/Spinner";
import moment from "moment";
import { useEffect, useState } from "react";
import { BiLink } from "react-icons/bi";
import { Link } from "react-router-dom";
import { getApi } from "common/services/api";
import EditTask from "./editDepartment";
import { useNavigate } from "react-router-dom";
import { constant } from "common/constant";
import { API_PATHS } from "common/services/apiPaths";

const JobProfileView = (props) => {
  const { onClose, isOpen, info, fetchData, setAction, action, access } = props;
  const [data, setData] = useState();
  const [edit, setEdit] = useState(false);
  const [deleteModel, setDelete] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const fetchViewData = async () => {
    if (info) {
      setIsLoading(true);
      let result = await getApi(
        API_PATHS.RECRUITMENT_PROFILES,
        info ? info : ""
      );
      setData(result?.data);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchViewData();
  }, [action, info]);

  const handleViewOpen = () => {
    if (info?.event) {
      navigate(`/view/${info?.event?.id}`);
    } else {
      navigate(`/view/${info}`);
    }
  };
  return (
    <Modal isOpen={isOpen} size={"md"} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader justifyContent="space-between" display="flex">
          Job Profile
          <IconButton
            size="xs"
            className="closeIcon"
            onClick={() => onClose(false)}
            icon={<CloseIcon />}
          />
        </ModalHeader>
        {isLoading ? (
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            mb={30}
            width="100%"
          >
            <Spinner />
          </Flex>
        ) : (
          <>
            <ModalBody>
              <Grid templateColumns="repeat(12, 1fr)" gap={3}>
                <GridItem colSpan={{ base: 12, md: 6 }}>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    color={"blackAlpha.900"}
                  >
                    {" "}
                    Department Title{" "}
                  </Text>
                  <Text>{data?.name ? data?.name : " - "}</Text>
                </GridItem>
              </Grid>
            </ModalBody>
            <DrawerFooter>
              {access?.view ||
                (user?.role === "superAdmin" && (
                  <IconButton
                    variant="outline"
                    colorScheme={"green"}
                    onClick={() => handleViewOpen()}
                    borderRadius="10px"
                    size="md"
                    icon={<ViewIcon />}
                  />
                ))}
              {access?.update ||
                (user?.role === "superAdmin" && (
                  <IconButton
                    variant="outline"
                    onClick={() => setEdit(true)}
                    ml={3}
                    borderRadius="10px"
                    size="md"
                    icon={<EditIcon />}
                  />
                ))}
              {access?.delete ||
                (user?.role === "superAdmin" && (
                  <IconButton
                    colorScheme="red"
                    onClick={() => setDelete(true)}
                    ml={3}
                    borderRadius="10px"
                    size="md"
                    icon={<DeleteIcon />}
                  />
                ))}

              <EditTask
                setAction={setAction}
                isOpen={edit}
                onClose={setEdit}
                viewClose={onClose}
                id={info?.event ? info?.event?.id : info}
                from="view"
              />
              {/* <DeleteTask fetchData={props.fetchData} isOpen={deleteModel} onClose={setDelete} viewClose={onClose} url='api/task/delete/' method='one' id={info?.event ? info?.event?.id : info} /> */}
            </DrawerFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default JobProfileView;
